import React, { useEffect, useState } from "react";
import { Calendar, Clock } from "lucide-react";
import { BROUILLON, compteARebours, instantFin, texteJour } from "../../lib/etatCampagne";

// Rafraîchissement du compte à rebours (il s'affiche à la minute près).
const INTERVALLE_MS = 30 * 1000;

/**
 * Date de fin d'une campagne encore ouverte (ou en aperçu) :
 *   « Dons ouverts jusqu'au jeudi 15 octobre inclus »
 * et, dans les 72 dernières heures seulement, « plus que 5 h 07 min ».
 * Le dernier jour compte en entier (jusqu'à minuit, heure de Paris), comme
 * le serveur. Rien sans date de fin. Une campagne terminée n'affiche pas
 * ce bloc (voir MerciCampagneTerminee).
 */
export default function EcheanceCampagne({ etat, reservation = false }) {
  const [maintenant, setMaintenant] = useState(() => Date.now());
  const fin = etat?.fin_le ? instantFin(etat.fin_le) : null;
  // Le minuteur ne tourne que lorsque la fin approche (≤ 73 h) : aucune
  // horloge inutile sur une campagne de plusieurs semaines.
  const proche = fin != null && etat?.dons_acceptes && fin - maintenant <= 73 * 3600 * 1000;

  useEffect(() => {
    if (!proche) return undefined;
    const id = setInterval(() => setMaintenant(Date.now()), INTERVALLE_MS);
    return () => clearInterval(id);
  }, [proche]);

  const jour = etat?.fin_le ? texteJour(etat.fin_le) : null;
  if (!jour) return null;
  const rebours = compteARebours(etat, maintenant);

  return (
    <div className="mb-6 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm text-stone-500"
      data-testid="echeance-campagne">
      <span className="inline-flex items-center gap-1.5 text-center">
        <Calendar className="h-4 w-4 shrink-0 text-stone-400" />
        {etat.code === BROUILLON
          ? `Fin prévue le ${jour}`
          : `${reservation ? "Réservations ouvertes" : "Dons ouverts"} jusqu'au ${jour} inclus`}
      </span>
      {rebours && (
        <span className="inline-flex items-center gap-1.5 font-semibold text-amber-700"
          data-testid="compte-a-rebours">
          <Clock className="h-4 w-4" />
          plus que {rebours}
        </span>
      )}
    </div>
  );
}
